import ThirdPartyFooterActions from './third-party-footer-actions';

export default ThirdPartyFooterActions;
